export default {
  logoDescription: 'Seleccione un fichero (.JPG o .GIF) con el logotipo de su empresa para su inclusión en la visualización de las facturas que emita. La imagen del fichero no podrá exceder los 200 píxeles de ancho por 200 píxeles de alto.',
  ownerDescription: 'Si lo desea puede seleccionar un fichero XSLT de transformación del formato propietario de la UBL 1.0. También, puede otorgarle un nombre al fichero de origen.',
  ownerFile: 'Fichero XSLT',
  inputDescription: 'Nombre del fichero',
  logoLabel: 'Logotipo',
  pdfConfg: 'Seleccione una de las plantillas para la visualización en PDF de las facturas. Las facturas que se emitan a partir de ahora, quedarán asociadas a esta plantilla.',
  template: 'Plantilla',
  seeExample: 'Ver Factura Ejemplo PDF',
  formatDescription: 'Seleccione uno de los siguientes formatos para la recepción de facturas firmadas. Si selecciona el valor "Formato Entrante", recibirá las facturas firmadas en el formato utilizado por el emisor de la misma.',
  format: 'Formato',
  logoFormats: '{0}: JPG, GIF',
  titles: {
    first: 'Selección del formato en el que desea recibir las facturas',
    second: 'Configuración de la plantilla de PDF para la visualización de facturas',
    third: 'Configuración del logotipo en la visualización de facturas',
    fourth: 'Configuración de formato propietario para poder importar facturas en la plataforma'
  },
  billFormat: {
    text: '{0}: 200 píxeles de alto por 200 píxeles de ancho',
    label: 'Dimensiones',
    file: '{0}: XSLT'
  }
}
